import { FC } from 'react';
import { Tag } from '@packages/utils';
import { Tooltip } from 'components/Base/Tooltip';
import { TTagEllipsisProps } from './TagEllipsis.types';

export const TagEllipsis: FC<TTagEllipsisProps> = ({
  text,
  textMaxLength,
  alwaysShowTooltip = false,
  ...tagProps
}) => {
  const isLonger = text?.length > textMaxLength;
  const tooltipTitle = alwaysShowTooltip || isLonger ? text : '';
  return (
    <Tooltip title={tooltipTitle}>
      <Tag {...tagProps}>
        {isLonger ? `${text?.slice(0, textMaxLength)}...` : text}
      </Tag>
    </Tooltip>
  );
};
